export const FAQdata = [
    {
        question: 'How much does it cost to join Trybe as a creator?',
        answer: 'No upfront or flat flees. We charge a 20% share of revenues earned through Trybe. The 20% is invested into new software features and services to help you grow your business and improve the end user’s experience.',
    },
    {
        question: 'Why do you do a revenue share model instead of a flat fee?',
        answer: 'This lets our creators launch with no risk of being charged more than they earn through Trybe. This gives you the ability to grow your app profitably from the start. As you grow, the revenue share allows us to continue adding new features and pay for overhead like storage costs and maintenance.',
    },
    {
        question: 'Who can apply to join Trybe?',
        answer: 'We encourage any fitness or mindfulness creator who is committed to building a strong community to apply.',
    },
    {
        question: 'How do I apply to join?',
        answer: 'You can apply here and we’ll reach out to you if we think we’re a good fit for you.',
        link: 'https://trybesl.typeform.com/to/nyjnzF3P',
        wordIndex: 4
    },
    {
        question: 'What happens after I’m accepted to join Trybe?',
        answer: 'We’ll reach out to you to set up a call and our team will take you through the onboarding steps to launch your Trybe app.',
    },
    {
        question: 'How will my audience find the app?',
        answer: 'We provide you with a unique link to share with your audience. This link will direct users to the app and ensure the app only shows your content and brand. If a user downloads Trybe without clicking on a creator’s unique link, they will be able to find you on our coach directory.',
    },
    {
        question: 'Do my users see content from other coaches?',
        answer: 'No, we respect the relationship between you and your users. Once a user joins your app through your link, they will only be able to see your content and brand. If users choose to support more than one creator on Trybe through a creator’s unique link, they will be able to switch between apps on the fly.',
    },
    {
        question: 'Who owns the content I upload on Trybe?',
        answer: 'You do. We don’t take any ownership of the content you upload to Trybe. We are here to provide you with the tools needed to run a successful subscription business. We love sharing what creators are doing with the Trybe platform. If you’re comfortable with us sharing your content, we periodically feature different creators on our social media accounts.',
    },
    {
        question: 'How will I get paid?',
        answer: 'We use Stripe Connect to handle payment processing. Stripe gives you ownership and transparency over your subscribers and payments. Once a subscriber pays, the funds are immediately sent to you. \n If Stripe is not available in your country (see here for list of supported countries), reach out and there’s a good chance we’ll be able to support payment processing for you.',
        link: 'https://stripe.com/global',
        wordIndex: 41
    }
]


// WEBPACK FOOTER //
// ./src/components/pages/tempFAQdata.js